(function () {
  'use strict';

  const dynamicGrid = $( '.dynamic-grid' )
  
  if (!dynamicGrid.length) return

  // Grid filters (using https://isotope.metafizzy.co)
  // ----------------------------------------
  var grid = dynamicGrid.isotope( {
    itemSelector: '.dynamic-grid-item'
  })

  $( '.dynamic-grid-filter' ).on( 'click', 'button', function() {
    var filterValue = $(this).attr( 'data-filter' )

    $( '.dynamic-grid-filter button' ).removeClass( 'active' )
    $(this).addClass( 'active' )

    grid.isotope( {
      filter: filterValue,
    })
  })

  // Custom show more logic
  // ----------------------------------------
  var initShow = 8
  var counter = initShow
  var iso = grid.data('isotope')

  loadMore(initShow)

  function loadMore(toShow) {
    grid.find( '.hidden-grid-item' ).removeClass( 'hidden-grid-item' )

    var hiddenElems = iso.filteredItems
      .slice(toShow, iso.filteredItems.length)
      .map(function(item) {
        return item.element
      })
    $(hiddenElems).addClass('hidden-grid-item');

    var visibleElems = iso.filteredItems
      .slice(0, toShow)
      .map(function(item) {
        return item.element
      })

    $(visibleElems).find('img[data-src]').each(function() {
      $(this).attr('src', $(this).data('src'))
      $(this).removeAttr('data-src')
    })

    grid.isotope( 'layout' )

    if (hiddenElems.length == 0) {
      jQuery( '#load-more' ).hide()
    } else {
      jQuery( '#load-more' ).show()
    }
  }

  $( '#load-more' ).click(function() {
    if ($( '#filters' ).data( 'clicked' )) {
      counter = initShow
      $( '#filters' ).data( 'clicked', false )
    } else {
      counter = counter
    }

    counter = counter + initShow

    loadMore(counter)
  })

  $( '#filters' ).click(function() {
    $(this).data( 'clicked', true )

    loadMore(initShow)
  })
})()